<template>
  <div>
    <LabelText :label-for="name">
      {{ label }}
    </LabelText>
    <BaseTextarea
      :id="name"
      :field-class="fieldClass"
      :value="_value"
      :name="name"
      :placeholder="placeholder"
      :rows="rows"
      :auto-grow="autoGrow"
      :disabled="disabled"
      :col="col"
      :empty-str-to-null="emptyStrToNull"
      :errors="errors"
      v-on="$listeners" />
  </div>
</template>

<script>
import LabelText from '@/components/parts/LabelText.vue'
import BaseTextarea from '@/components/parts/BaseTextarea.vue'
export default {
  name: 'BaseTextareaGroup',
  components: {
    LabelText,
    BaseTextarea,
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      default: () => []
    },
    col: {
      type: [String, Number],
      default: 12
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 5
    },
    autoGrow: {
      type: Boolean,
      default: false
    },
    fieldClass: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
}
</script>

<style>

</style>